<script>

    import { toast } from 'bulma-toast'
    import { accountStore, accountsStore, modalStore } from '../stores'

    import AccountsService from '../$services/accounts.service.js'
    import DateMethod from '../$methods/date.method.js'
    import NumeralMethods from '../$methods/numeral.methods.js'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import Button from '../$components/button.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let loading = false
    let data = {}
    let element

    getAccountDetails()

    async function getAccountDetails() {

        data = {}

        loading = true
        const resp = await AccountsService.getAccountDetails($accountStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        data = resp.data
    }

    async function deleteAccount() {

        loading = true
        const resp = await AccountsService.deleteAccount($accountStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountsStore.remove($accountStore._id)
        toast({message: 'Cuenta borrada', type: 'is-success'})
        
        modalStore.set('user_modal')
    }

    async function getShipmentsReport() {
    
        loading = true
        const blob = await AccountsService.getShipmentsReport($accountStore._id)
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = `${ $accountStore.user.email }_reportes_envios_${ DateMethod.dateShort($accountStore.expired) }`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

    async function getChargesReport() {
    
        loading = true
        const blob = await AccountsService.getChargesReport($accountStore._id)
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = `${ $accountStore.user.email }_reportes_cargos_${ DateMethod.dateShort($accountStore.expired) }`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }
    
</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title="Cuenta"
        meta={DateMethod.dateTimeLarge($accountStore.created)}
        statusValue={$accountStore.status}
    >
        <DetailsFields>
            {#if $accountStore.admin.name}
                <DetailsField label="Admin">
                    <div>
                        <div>{ $accountStore.admin.name }</div>
                        <div>{ $accountStore.admin.email }</div>
                    </div>
                </DetailsField>
            {/if}
            <DetailsField label="Usuario">
                <div>
                    <div>{ $accountStore.user.name }</div>
                    <div>{ $accountStore.user.email }</div>
                </div>
            </DetailsField>
            {#if $accountStore.status === 'paid'}
                <DetailsField label="Fecha de pago" value={DateMethod.dateTimeLarge($accountStore.payment)} />
            {/if}
            <DetailsField label="Referencia" value={$accountStore.reference || ''} />
            <DetailsField label="Ciclo" value={$accountStore.cycleType} />
            {#if $accountStore.cycleType === 'weekly'}
                <DetailsField label="Día" value={$accountStore.cycleDay} />
            {/if}
            <DetailsField label="Renovación automática" value={$accountStore.autoRenew ? 'Sí' : 'No'} />
            <DetailsField label="Envíos">
                <div>{ $accountStore.shipments.length } | { NumeralMethods.cash(data.shipments) }</div>
            </DetailsField>
            <DetailsField label="Cargos">
                <div>{ NumeralMethods.cash(data.charges) }</div>
            </DetailsField>
            <DetailsField label="Reembolsos">
                <div>{ NumeralMethods.cash(data.refunds) }</div>
            </DetailsField>
            <DetailsField label="Total">
                <div>{ NumeralMethods.cash(data.shipments + data.charges - data.refunds) }</div>
            </DetailsField>
            <DetailsField label="Inicio" value={DateMethod.dateTimeLarge($accountStore.activated)} />
            <DetailsField label="Corte" value={DateMethod.dateTimeLarge($accountStore.expired)} />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <Button on:click={getChargesReport} icon="file-pdf" text="Reporte cargos" />
                    <Button on:click={getShipmentsReport} icon="file-pdf" text="Reporte envíos" />
                    <ButtonModal modalId="account_update_modal" icon="edit" text="Actualizar" />
                    <ButtonDelete on:confirm={deleteAccount} {loading} />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}
